import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";


export const updateExamDetails = createAsyncThunk(
  "answerExam/updateExamDetails",
  async ({ user_id, exam_id, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://wfjgofigsh.execute-api.us-east-1.amazonaws.com/sqa/update-exam-details",
        { user_id, exam_id },
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` } }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


// Async thunk for fetching exam questions
export const fetchQuestions = createAsyncThunk(
  "answerExam/fetchQuestions",
  async ({ user_id, exam_id, fetch_type, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://ltyivcs05d.execute-api.us-east-1.amazonaws.com/sqa/get-exam-questions",
        { user_id, exam_id, fetch_type },
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` } }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Async thunk for fetching exam questions
export const generatePDF = createAsyncThunk(
  "answerExam/generatePDF",
  async ({ user_id, exam_id, fetch_type, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://pgi8x8o3b5.execute-api.us-east-1.amazonaws.com/sqa/generate-pdf",
        { user_id, exam_id, fetch_type },
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` } }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Async thunk for submitting an answer
export const submitAnswer = createAsyncThunk(
  "answerExam/submitAnswer",
  async ({ user_id, exam_instance_id, question_id, student_option, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://u35rklncl7.execute-api.us-east-1.amazonaws.com/sqa/answer-question",
        { user_id, exam_instance_id, question_id, student_option },
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` } }
      );
      return response.data; // API may return some status
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Exam slice
const answerExamSlice = createSlice({
  name: "answerExam",
  initialState: {
    loading: false,
    questions: [],
    error: null,
    answerStatus: null, // Track the answer submission status
    examUpdateStatus: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuestions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuestions.fulfilled, (state, action) => {
        state.loading = false;
        state.questions = action.payload;
      })
      .addCase(fetchQuestions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(submitAnswer.pending, (state) => {
        state.answerStatus = "loading";
      })
      .addCase(submitAnswer.fulfilled, (state, action) => {
        state.answerStatus = "success";
      })
      .addCase(submitAnswer.rejected, (state, action) => {
        state.answerStatus = "error";
        state.error = action.payload;
      })
      .addCase(updateExamDetails.pending, (state) => {
        state.examUpdateStatus = "loading";
      })
      .addCase(updateExamDetails.fulfilled, (state, action) => {
        state.examUpdateStatus = "success";
      })
      .addCase(updateExamDetails.rejected, (state, action) => {
        state.examUpdateStatus = "error";
        state.error = action.payload;
      }).addCase(generatePDF.pending, (state) => {
        state.answerExamloading = true;
        state.error = null;
      })
      .addCase(generatePDF.fulfilled, (state, action) => {
        state.answerExamloading = false;
        state.questions = action.payload;
      })
      .addCase(generatePDF.rejected, (state, action) => {
        state.answerExamloading = false;
        state.error = action.payload;
      });
  },
});

export default answerExamSlice.reducer;
